<template>
    <div class="content">
        <pageTool></pageTool>
        <Header
            :page-title="title"
        ></Header>
        <div class="page-content">
            <div class="page-text page-text-block">
                <div class="li-header">我的咨询</div>
                <div class="qus-content">
                    <a-carousel autoplay>
                        <div v-for="(img, i) in rtData.imgList" :key="i"><img :src="title.internalInstance.appContext.config.globalProperties.$imgUrl + img"></div>
                    </a-carousel>
                    <p>{{ rtData.data.msg }}</p>
                    <p>{{ rtData.data.updateTime }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import {getCurrentInstance, onMounted, reactive} from "@vue/runtime-dom"
import pageTool from "@/components/nav/pageTool"
import {getTechnologyDetailApi} from "@/api/technology"
import {useRoute} from "vue-router"
const banner = require('@/assets/img/page_banner_1.png')
export default {
    name: "TechnicalDetail",
    setup() {
        const route = useRoute()
        const title = reactive({
            cn: '技术咨询',
            en: 'TECHNICAL CONSULTING',
            hasSearch: false,
            titleStyle: false,
            banner,
            internalInstance: getCurrentInstance(),
        })
        const rtData = reactive({
            imgList: [],
            data: {}
        })
        const getTechnologyDetail = async (id) => {
            const data = await getTechnologyDetailApi(id)
            rtData.imgList = data.imgs ? data.imgs.split(',') : ''
            rtData.data = data
        }
        onMounted(() => {
            getTechnologyDetail(route.query.id)
        })
        return {
            title,
            rtData,
        }
    },
    components: {
        Header,
        pageTool
    }
}
</script>


<style scoped lang="stylus">
.content {
    .page-content {
        padding 20px 15px
        background-color #FFF
        .page-content-button {
            width 100%
            text-align center
            .cus-button {
                width 199px
                background #03CA8F
                border-radius 6px
                border-color #03CA8F
                margin-bottom 15px
            }
        }
        .page-text-block {
            padding 15px 20px
            box-shadow 0 3px 6px rgba(0, 0, 0, 0.16)
            border-radius 3px
            .qus-content {
                width 100%
                padding 10px
                font-size 16px
                color #44A73D
            }
        }
    }
}
</style>